<template>
  <v-container fluid class="fill-height">
    <v-row justify="center" align="center" class="fill-height">
      <v-col cols="12" md="6" class="text-center">
        <v-icon size="64" color="grey">mdi-map-marker-question-outline</v-icon>
        <h1 class="text-h4 mt-4">Page introuvable</h1>
        <p class="mt-2 grey--text">
          L'adresse demandée n'existe pas ou n'est plus disponible.
        </p>
        <v-btn color="primary" class="mt-4" to="/">
          <v-icon class="mr-2">mdi-home</v-icon>
          Retour à l'accueil
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { reportError } from '@/services/errorReportingApi'

export default {
  name: 'NotFoundView',
  created() {
    reportError({
      context: 'route:404',
      url: this.$route.fullPath,
      message: 'Route not found',
    })
  },
}
</script>
